<template>
    <div id="tag_list">
        <div class="page_header tag_header main_between cross_center" style="padding-top: 20px; padding-bottom: 20px;">
            <a-button type="primary" @click="toOpen">添加标签</a-button>
            <a-button icon="sync" @click="refresh">刷新标签缓存</a-button>
        </div>
        <div class="page_content tag_content">
            <a-table
                :columns="columns"
                :data-source="dataList"
                :row-key="(record) => record.groupId"
                :row-selection="{ selectedRowKeys: selectedIds, onChange: selectChange }"
                :pagination="false"
                :loading="loading"
            >
                <template slot="tag" slot-scope="text, record">
                    <div class="dir_left_wrap">
                        <a-tag
                            v-for="item in record.tag"
                            :key="item.tagId"
                            style="margin-bottom: 5px;"
                        >
                            {{ item.tagName }}
                        </a-tag>
                    </div>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a-button-group size="small">
                        <a-button type="link" @click="toEdit(record)">编辑</a-button>
                        <a-divider type="vertical" />
                        <a-button type="link" @click="toDel([record.groupId])">删除</a-button>
                    </a-button-group>
                </template>
                <template slot="footer" style="background: #fff">
                    <a-button @click="toDel(selectedIds)">批量删除</a-button>
                </template>
            </a-table>
        </div>
        <a-modal :title="title" :visible="visible" @cancel="toCancel" @ok="toCheck">
            <a-form-model :model="formData" ref="tagForm" :rules="rules">
                <a-form-model-item label="标签组名称" prop="groupNameValue">
                    <a-input
                        v-model="formData.groupName"
                        v-if="visibleEdit"
                        placeholder="标签组名称"
                        @change="getStringLengthForChinese(formData.groupName, 'groupName')"
                    />
                    <a-input
                        v-model="formData.groupNameValue"
                        v-else
                        placeholder="标签组名称"
                        @change="
                            getStringLengthForChinese(formData.groupNameValue, 'groupNameValue')
                        "
                    />
                </a-form-model-item>
                <a-form-model-item label="标签" prop="tagName">
                    <template v-for="item in formData.tag">
                        <a-tag :key="item.tagId" closable @close="tagChange(item)">
                            {{ item.tagName }}
                        </a-tag>
                    </template>
                    <template v-for="(item, index) in formData.tagName">
                        <a-tag :key="index" @click="tagChange(index)" :title="item">
                            {{ item }} <a-icon type="close" />
                        </a-tag>
                    </template>
                    <template>
                        <a-input
                            v-model="formData.tagNameValue"
                            allowClear
                            @change="addTagChange"
                            @blur="addTag"
                            @pressEnter="addTag"
                            style="width: 88px"
                            v-if="inputVisible"
                        />
                        <a-button v-else @click="inputVisible = true" size="small"
                            >添加标签</a-button
                        >
                    </template>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
export default {
    // 标签列表
    name: 'tag_list',
    props: {
        show: {
            type: Boolean,
            default: () => false
        },
    },
    data() {
        return {
            visible: false,
            inputVisible: false,
            loading: false,
            title: '',
            selectedIds: [],
            columns: [
                {
                    title: '标签组',
                    key: 'groupName',
                    dataIndex: 'groupName',
                    width: 200
                },
                {
                    title: '标签',
                    key: 'tag',
                    scopedSlots: { customRender: 'tag' }
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150,
                    scopedSlots: { customRender: 'action' }
                }
            ],
            dataList: [],
            formData: {
                groupNameValue: '',
                tagNameValue: '',
                tagName: [],
                tag: [],

            },
            rules: {
                groupNameValue: [{ required: true, message: '标签组名称不能为空' }]
                // tagName: [
                //     { required: true, type: 'array', trigger: 'blur', message: '标签不能为空' }
                // ]
            },
            // 最大字符
            maxLength: 30,
            // 判断当前是否编辑状态
            visibleEdit: false
        };
    },
    mounted() {
        if (this.show) this.init();
    },
    methods: {
        // 初始数据
        async init(type) {
            this.loading = true;
            try {
                const params = {};
                if (type && type === 'yes') params.refresh = type;
                const res = await api.getTag(params);
                this.loading = false;
                if (res.code !== 0) return;
                this.dataList = res.tagGroup;
            } catch (err) {
                console.log(err);
                this.loading = false;
            }
        },
        // 刷新
        refresh() {
            this.init('yes');
        },
        // 弹框
        toOpen() {
            this.title = '添加标签';
            this.visible = true;
        },
        toEdit(e) {
            this.formData = e;
            this.formData.delTagId = [];
            this.formData.tagName = [];
            this.title = '编辑标签';
            this.visible = true;
            this.formData.groupNameValue = e.groupName;
            this.visibleEdit = true;
            this.rules.groupName = [{ required: true, message: '标签组名称不能为空' }];
            delete this.rules.groupNameValue;
        },
        addTag() {
            let oldTags = [];
            if (this.formData.tag && this.formData.tag.length > 0)
                oldTags = _.map(this.formData.tag, 'tagName');
            const tagList = [...oldTags, ...this.formData.tagName];
            // 清空首尾空格
            const tagNameValue = this.formData.tagNameValue.trim();
            if (tagList.length > 0 && _.indexOf(tagList, tagNameValue) > -1)
                return this.$message.error('标签已添加');
            if (tagNameValue && tagNameValue.length > 0) this.formData.tagName.push(tagNameValue);
            this.inputVisible = false;
            this.formData.tagNameValue = '';
        },
        // 操作
        async toCheck() {
            try {
                if (this.formData.groupId) {
                    if (this.formData.tagName.length > 0) {
                        const dataForTagCreate = {
                            groupId: this.formData.groupId,
                            tagName: this.formData.tagName
                        };
                        let resp = await api.postTag(dataForTagCreate);
                        if (resp.code !== 0) return this.$message.error(`${resp.code}-${resp.msg}`);
                    }
                    if (this.formData.groupName !== this.formData.groupNameValue) {
                        if (!this.formData.groupName)
                            return this.$message.warning('标签组名称不能为空');
                        this.formData.groupNameValue = this.formData.groupName;
                        const dataForTagGroup = {
                            id: this.formData.groupId,
                            name: this.formData.groupNameValue
                        };
                        let res = await api.updateTag(dataForTagGroup);
                        if (res.code !== 0) return;
                        this.$message.success('标签组修改成功');
                    }
                    // 删除标签
                    if (this.formData.delTagId.length > 0) {
                        try {
                            const res = await api.delTag({ tagId: this.formData.delTagId });
                            if (res.code !== 0) return;
                        } catch (err) {
                            console.log(err);
                        }
                    }
                    this.toCancel();
                } else {
                    if (this.formData.tagName.length === 0)
                        return this.$message.warning('还未添加标签');
                    this.formData.groupName = this.formData.groupNameValue;
                    this.$refs.tagForm.validate(async (valid) => {
                        if (valid) {
                            let res = await api.postTag(this.formData);
                            if (res.code !== 0) return;
                            this.$message.success('标签组添加成功');
                            this.toCancel();
                            this.init();
                        }
                    });
                }
            } catch (err) {
                console.log(err);
            }
        },
        async toDel(groupId) {
            const that = this;
            if (groupId.length === 0) return that.$message.error('未选择标签组');
            try {
                this.$confirm({
                    title: `确认删除？`,
                    icon: 'info-circle',
                    async onOk() {
                        try {
                            const res = await api.delTag({ groupId });
                            if (res.code !== 0) return;
                            that.$message.success('删除成功');
                            that.init();
                        } catch (err) {
                            return that.$message.error(`${err}`);
                        }
                    },
                    onCancel() {}
                });
            } catch (err) {
                console.log(err);
            }
        },
        toCancel() {
            if (this.visibleEdit) this.init();
            this.visible = false;
            this.visibleEdit = false;
            this.inputVisible = false;
            this.formData = {
                groupNameValue: '',
                tagNameValue: '',
                tagName: [],
                tag: []
            };
            this.$refs.tagForm.resetFields();
            this.rules.groupNameValue = [{ required: true, message: '标签组名称不能为空' }];
            delete this.rules.groupName;
        },
        tagChange(e) {
            if (e.tagId) {
                this.formData.tag = this.formData.tag.filter((item) => item.tagId !== e.tagId);
                this.formData.delTagId.push(e.tagId);
            } else {
                const index = e;
                this.formData.tagName.splice(index, 1);
            }
        },
        selectChange(e) {
            this.selectedIds = e;
        },
        addTagChange() {
            if (!this.formData.tagNameValue) this.inputVisible = false;
            this.getStringLengthForChinese(this.formData.tagNameValue, 'tagNameValue');
        },
        getStringLengthForChinese(val, sub) {
            let str = val.toString();
            let strArr = str.split('');
            let bytesCount = 0;
            for (let i = 0, len = str.length; i < len; i++) {
                let c = str.charCodeAt(i);
                if ((c > 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
                    //这里是16进制表示，也可以用十进制
                    bytesCount = bytesCount + 1;
                } else {
                    bytesCount = bytesCount + 2;
                }
            }
            if (this.maxLength < bytesCount && sub) {
                const newArr = [];
                strArr.forEach((item, index) => {
                    if (index !== strArr.length - 1) newArr.push(item);
                });
                this.formData[sub] = newArr.join('');
                this.$message.warning('最多30个字符。');
                return;
            }
        }
    }
};
</script>

<style>
#tag_list .ant-table-body {
    max-height: calc(100vh - 307px) !important;
    overflow-y: auto !important;
}
#tag_list .ant-table-footer {
    background: #fff;
    padding-left: 0;
    padding-right: 0;
}
</style>
